import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";
import NotificationBell from "./NotificationBell";
import Search from "./Search";
import { Separator } from "./ui/separator";
import { SidebarTrigger } from "./ui/sidebar";
import UserProfileDropdown from "./UserProfileDropdown";

interface AppHeaderProps {
  onSearch?: (query: string) => void;
  notificationCount?: number;
  userName?: string;
  userEmail?: string;
  className?: string;
}

const AppHeader = ({
  onSearch,
  notificationCount = 0,
  userName,
  userEmail,
  className,
}: AppHeaderProps) => {
  const navigate = useNavigate();

  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  return (
    <header
      className={cn(
        "flex h-17 shrink-0 items-center gap-4 border-b bg-background px-4 md:px-6",
        className
      )}
    >
      {/* Sidebar Trigger */}
      <SidebarTrigger className="-ml-1" />

      <Separator orientation="vertical" className="h-6" />

      {/* Search - takes available space */}
      <div className="flex-1 max-w-md">
        <Search
          placeholder="Search students, staff, programs..."
          onValueChange={(query) => {
            // Handle search on Enter key (handled internally by Search component)
            if (onSearch) {
              onSearch(query);
            } 
          }}
          className={{
            inputGroupClass: "w-full",
          }}
        />
      </div>

      {/* Right section - Notifications & User Profile */}
      <div className="ml-auto flex items-center gap-2">
        <NotificationBell
          count={notificationCount}
          onClick={handleNotificationClick}
        />

        <Separator orientation="vertical" className="h-6" />

        <UserProfileDropdown userName={userName} userEmail={userEmail} />
      </div>
    </header>
  );
};

export default AppHeader;
